import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { v4 as uuidv4 } from 'uuid';
import { connect } from 'react-redux';
import moment from 'moment';
import {
  Button,
  Col,
  Container,
  ModalBody,
  ModalFooter,
  Row,
} from 'reactstrap';
import { injectIntl } from 'react-intl';

import { APIgetDownloadRequestFiles } from '../../api/Downloads';
import { APIgetFiles } from '../../api/Files';
import {
  APIcreateShare,
  APIupdateShare,
  APIgetShareSummary,
  APIgetShareInfo,
  APIgetShareSettings,
  APIcreateShareTemplate,
} from '../../api/Shares';

import ShareModalHeader from './ModalHeader';
import ShareModalComment from './ModalComment';
import ShareModalLinkSharing from './ModalLinkSharing';
import ShareModalIncludeFutureFiles from './ModalIncludeFutureFiles';
import ShareModalView from './ModalView';
import ShareModalExpirationDate from './ModalExpirationDate';
import ShareModalWatermark from './ModalWatermark';
import ShareModalAllowDownload from './ModalAllowDownload';
import ShareModalRequireLogin from './ModalRequireLogin';
import ShareModalPasswordProtect from './ModalPasswordProtect';
import ShareModalAllowComments from './ModalAllowComments';
import ShareModalShowPeople from './ModalShowPeople';
import ShareModalStatusChange from './ModalStatusChange';
import ShareModalRequireName from './ModalRequireName';
import ShareModalRequireEmail from './ModalRequireEmail';
import ShareModalRequireAcceptDocument from './ModalRequireAcceptDocument';
import ShareModalSelectFileSizes from './ModalSelectFileSizes';
import ShareModalAllowFavoriting from './ModalAllowFavoriting';
import ShareModalAllowVersions from './ModalAllowVersions';
import ShareModalTemplates from './ModalTemplates';
import ShareModalColor from './ModalColor';
import ShareModalLogo from './ModalLogo';
import ShareModalHideFileDetails from './ModalHideFileDetails';
import ShareModalDownloadReasons from './ModalDownloadReasons';

import ProcessingSpinner from '../ProcessingSpinner';
import ErrorBoundary from '../ErrorBoundary';
import Loading from '../Loading';

import { sendTrackingEvent } from '../../helpers';
import { addFlashMessage } from '../../helpers/FlashMessages';
import { isValidShareLinkSuffix } from '../../helpers/Validators';
import {
  canUserManageShare,
  getShareOptionValue,
  shareUserSettingsMap,
} from '../../helpers/Share';
import { userHasFeature } from '../../helpers/Features';
import { performOnboardingStep } from '../../helpers/Onboarding';
import { getSetting } from '../../helpers/Settings';

class ShareModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mode: null,
      editing: false,
      unsaved: false,
      shareUuid: null,
      files: [],
      all_collections: [],
      collections: [],
      expirationDate: null,
      linkRequireLogin: false,
      comment: '',
      allowDownload: true,
      downloadReasons: false,
      requirePassword: false,
      password: '',
      passwordError: false,
      allowComments: false,
      showPeople: false,
      watermark: false,
      userCanDownload: false,
      hasRestrictedFiles: false,
      includeFutureFiles: true,
      requireName: false,
      requireEmail: false,
      requireAcceptDocument: false,
      selectFileSizes: false,
      fileSizes: [],
      allowFavoriting: false,
      allowVersions: false,
      hideFileDetails: false,
      logo: null,
      logoUrl: null,
      color: null,
      userDownloadableFiles: 0,
      userDownloadableCollections: 0,
      view: getSetting('default_files_view'),
      filesCount: 0,
      page: 1,
      filesLoadEnd: false,
      filesLoading: false,
      users: [],
      groups: [],
      selectedUsers: [],
      links: [],
      usersLoading: false,
      modalView: null,
      saving: false,
      savingPassword: false,
      statusChange: false,
      template: null,
      templates: [],
      templatesLoading: false,
      summary: {
        collections: 0,
        smart_collections: 0,
        files: 0,
        size: 0,
        downloadable_files: 0,
      },
      summaryLoading: true,
      shareLoading: props.share !== null,
      requestLoading: props.request !== null,
      initialStateLoading: true,
      addingTemplate: false,
      addingTemplateLoading: false,
      newTemplateName: '',
      newTemplateNameError: false,
      newTemplateDestination: 'user',
      errors: {},
    };

    this.addSelectedUser = this.addSelectedUser.bind(this);
    this.changeLinkSuffix = this.changeLinkSuffix.bind(this);
    this.changeExpirationDate = this.changeExpirationDate.bind(this);
    this.changeLinkRequireLogin = this.changeLinkRequireLogin.bind(this);
    this.resetModalView = this.resetModalView.bind(this);
    this.openSettings = this.openSettings.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleChangeComment = this.handleChangeComment.bind(this);
    this.handleChangeCheckbox = this.handleChangeCheckbox.bind(this);
    this.handleChangeTemplate = this.handleChangeTemplate.bind(this);
    this.handleChangeColor = this.handleChangeColor.bind(this);
    this.handleChangeLogo = this.handleChangeLogo.bind(this);
    this.handleChangeLogoUrl = this.handleChangeLogoUrl.bind(this);
    this.handleChangeAllowDownload = this.handleChangeAllowDownload.bind(this);
    this.handleChangeDownloadReasons = this.handleChangeDownloadReasons.bind(this);
    this.handleChangeRequirePassword = this.handleChangeRequirePassword.bind(this);
    this.handleChangePassword = this.handleChangePassword.bind(this);
    this.handleChangeAllowComments = this.handleChangeAllowComments.bind(this);
    this.handleChangeShowPeople = this.handleChangeShowPeople.bind(this);
    this.handleChangeAllowFavoriting = this.handleChangeAllowFavoriting.bind(this);
    this.handleChangeAllowVersions = this.handleChangeAllowVersions.bind(this);
    this.handleChangeHideFileDetails = this.handleChangeHideFileDetails.bind(this);
    this.handleChangeStatusChange = this.handleChangeStatusChange.bind(this);
    this.handleChangeWatermark = this.handleChangeWatermark.bind(this);
    this.handleChangeIncludeFutureFiles = this.handleChangeIncludeFutureFiles.bind(this);
    this.handleChangeRequireName = this.handleChangeRequireName.bind(this);
    this.handleChangeRequireEmail = this.handleChangeRequireEmail.bind(this);
    this.handleChangeRequireAcceptDocument = this.handleChangeRequireAcceptDocument.bind(this);
    this.handleChangeSelectFileSizes = this.handleChangeSelectFileSizes.bind(this);
    this.handleChangeView = this.handleChangeView.bind(this);
    this.handleAddingTemplateWrapper = this.handleAddingTemplateWrapper.bind(this);
    this.handleFileSizesChange = this.handleFileSizesChange.bind(this);
    this.handleNewTemplateName = this.handleNewTemplateName.bind(this);
    this.handleNewTemplateNameError = this.handleNewTemplateNameError.bind(this);
    this.handleNewTemplateDestination = this.handleNewTemplateDestination.bind(this);
    this.loadShareTemplates = this.loadShareTemplates.bind(this);
  }

  componentDidMount() {
    const { share } = this.props;

    this.setInitialState();
    if (!share) {
      this.getShareSummary();
    }

    sendTrackingEvent('share-modal-open');
  }

  componentDidUpdate(prevProps) {
    const { accessSaving: prevAccessSaving } = prevProps;
    const { accessSaving } = this.props;
    const { selectedUsers } = this.state;

    if (selectedUsers.length > 0 && accessSaving && !prevAccessSaving) {
      this.handleSave(true);
    }
  }

  getShortLink() {
    const { links } = this.state;
    return links[0] ? links[0].short_link_url : { prefix: '', suffix: '' };
  }

  getShareSummary() {
    const {
      collections,
      files,
      request,
      share,
    } = this.props;
    const { all_collections: allCollections } = this.state;

    let shareCollections = request ?
      request.collections.map(c => c.uuid) :
      collections.map(c => c.uuid);
    let shareFiles = files.map(f => f.uuid);

    if (share) {
      shareCollections = allCollections.map(c => (c.uuid)) || [];
      shareFiles = [];
    }

    APIgetShareSummary({
      collections: shareCollections,
      files: shareFiles,
      request_uuid: request ? request.uuid : undefined,
    }).then((response) => {
      this.setState({
        summary: {
          collections: response.data.collections,
          smart_collections: response.data.smart_collections,
          files: response.data.files,
          downloadable_files: response.data.downloadable_files,
          size: response.data.size,
        },
        summaryLoading: false,
      }, () => {
        if (!share) {
          this.setDownloadableFiles();
        }
      });
      if (response.data.smart_collections > 0) {
        this.setState({ includeFutureFiles: true });
      }
    });
  }

  getSaveButtonText() {
    const { intl } = this.props;
    const { editing } = this.state;

    if (editing) {
      return intl.formatMessage({ defaultMessage: 'Save' });
    }

    return intl.formatMessage({ defaultMessage: 'Done' });
  }

  async loadShareTemplates(uuid = null) {
    this.setState({ templatesLoading: true });
    let templates = [];
    try {
      const response = await APIgetShareSettings({ type: 'all' });
      templates = response.data.share_templates;
    } catch (e) {
      templates = [];
    } finally {
      this.setState({ templates, templatesLoading: false });
    }

    if (uuid) {
      this.handleChangeTemplate({ value: uuid }, () => {}, true, templates);
    }
    return templates;
  }

  setDownloadableFiles() {
    const {
      files,
      collections,
      editing,
      allowDownload,
      summary,
      templates,
      template,
    } = this.state;

    let userDownloadableFiles = files.filter(f => (
      (f.capabilities.includes('all') && !f.capabilities.includes('request_download_files_and_collections')) ||
      (f.capabilities.includes('download_files_and_collections') || f.capabilities.includes('reason_download_files_and_collections')) ||
      (f.capabilities.includes('request_download_files_and_collections') && f.request)
    )).length;
    const userDownloadableCollections = collections.filter(c => (
      (
        c.capabilities.includes('all') ||
        (c.capabilities.includes('download_files_and_collections') || c.capabilities.includes('reason_download_files_and_collections'))
      ) &&
      !c.capabilities.includes('request_download_files_and_collections')
    )).length;
    let userCanDownloadFiles = files.length === userDownloadableFiles;
    if (summary.files > 0 && summary.downloadable_files < summary.files) {
      userCanDownloadFiles = false;
      userDownloadableFiles = summary.downloadable_files;
    }
    const userCanDownloadCollections = collections.length === userDownloadableCollections;

    const selectedTemplate = templates.find(p => p.uuid === template);

    const allowDownloadTrue = (selectedTemplate && 'allow_download' in selectedTemplate && selectedTemplate.allow_download) ||
      (!(selectedTemplate && 'allow_download' in selectedTemplate));

    this.setState({
      userDownloadableFiles,
      userDownloadableCollections,
      userCanDownload: userCanDownloadFiles && userCanDownloadCollections,
      allowDownload: editing ? allowDownload :
        userCanDownloadFiles && userCanDownloadCollections && allowDownloadTrue,
      hasRestrictedFiles: !userCanDownloadFiles || !userCanDownloadCollections,
    });
  }

  async setInitialState() {
    const {
      files,
      allFiles,
      collections,
      allCollections,
      request,
      share,
    } = this.props;

    let mode = 'share';
    if (request) {
      mode = 'request';
    }

    // Keep files order
    let shareFiles = [];
    if (mode === 'share' && !share) {
      const shareFilesUuids = files.map(sf => sf.uuid);
      const allFilesUuids = new Set(allFiles.map(f => f.uuid));
      const missingUuids = shareFilesUuids.filter(uuid => !allFilesUuids.has(uuid));

      let fetchedMissingFiles = [];
      if (missingUuids.length > 0) {
        const response = await APIgetFiles({ uuids: missingUuids });
        fetchedMissingFiles = response.data.data ?? [];
      }

      shareFiles = [
        ...allFiles.filter(f => shareFilesUuids.includes(f.uuid)),
        ...fetchedMissingFiles,
      ];
      if (shareFiles.length !== files.length) {
        shareFiles = files;
      }
    }
    this.setState({ initialStateLoading: false });

    // Keep collections order
    let shareCollections = [];
    if (mode === 'share' && !share) {
      const shareCollectionsUuids = collections.map(sc => (sc.uuid));
      shareCollections = allCollections.filter(c => (shareCollectionsUuids.includes(c.uuid)));
      if (shareCollections.length !== collections.length) {
        shareCollections = collections;
      }
    }

    if (mode === 'request') {
      APIgetDownloadRequestFiles(request.uuid, { short: true }).then((response) => {
        let requestFiles = [];
        if (response.data) {
          requestFiles = response.data;
        }
        if (collections.length > 0) {
          requestFiles = [];
        }
        this.setState({
          mode,
          files: files.length > 0 ? files : requestFiles,
          collections: request.collections,
          filesCount: files.length > 0 ? files.length : requestFiles.length,
          editing: share !== null,
          requestLoading: false,
        });
      });
    } else if (share) {
      this.loadShareTemplates();
      APIgetShareInfo(share.uuid).then((response) => {
        const { data } = response;
        if (data) {
          this.setState({
            mode,
            shareUuid: share.uuid,
            files: data.files,
            all_collections: data.all_collections,
            collections: data.collections,
            selectedUsers: data.links.map(l => ({ type: 'link', ...l })),
            expirationDate: data.expires_at ? moment(data.expires_at) : null,
            linkRequireLogin: data.login_required,
            comment: data.comment,
            allowDownload: data.allow_download,
            downloadReasons: data.download_reasons,
            requirePassword: data.require_password,
            password: data.password,
            statusChange: data.status_change,
            allowComments: data.allow_comments,
            showPeople: data.show_people,
            allowFavoriting: data.allow_favoriting,
            allowVersions: data.allow_versions,
            hideFileDetails: data.hide_file_details,
            watermark: data.watermark,
            includeFutureFiles: data.include_future_files,
            requireName: data.require_name,
            requireEmail: data.require_email,
            requireAcceptDocument: data.require_accept_document,
            selectFileSizes: data.select_file_sizes,
            fileSizes: data.file_sizes,
            template: data.template,
            view: data.view,
            color: data.color,
            logo: data.logo,
            logoUrl: data.logo_url,
            filesCount: data.files.length,
            allCollectionsCount: data.all_collections_count,
            links: data.links,
            editing: true,
            shareLoading: false,
          }, () => {
            this.setDownloadableFiles();
            this.getShareSummary();
          });
        } else {
          this.setState({ shareLoading: false });
        }
      });
    } else {
      const templates = await this.loadShareTemplates();
      const defaultTemplate = userHasFeature('share-templates')
        ? (templates.find(t => t.is_default) || templates.find(t => t.type === 'user'))
        : null;

      this.handleChangeTemplate(
        defaultTemplate ? { value: defaultTemplate.uuid } : null,
        () => {
          this.setState({
            mode,
            files: shareFiles,
            collections: shareCollections,
            filesCount: shareFiles.length,
            editing: false,
          }, () => this.setDownloadableFiles());
        },
        true,
        templates,
      );
    }
  }

  addSelectedUser(user) {
    const { setShareLink } = this.props;
    const { selectedUsers } = this.state;

    selectedUsers.push(user);
    this.setState({ selectedUsers }, () => {
      if (user.type === 'link') {
        this.handleSave(false);
        setShareLink(true);
      }
    });
  }

  changeLinkSuffix(e) {
    const { intl } = this.props;
    const { links } = this.state;
    links[0].short_link_url.suffix = e.target.value;
    this.setState({
      links,
      unsaved: true,
      errors: {},
    });
    if (!isValidShareLinkSuffix(e.target.value)) {
      const { errors } = this.state;
      errors.share_link_suffix = intl.formatMessage({ defaultMessage: 'Allowed characters for link suffix are: A-Z, a-z, 0-9, -, _' });
      this.setState({ errors });
    }
  }

  changeExpirationDate(expirationDate) {
    this.setState({ expirationDate }, () => {
      this.updateShareIfNecessary();
    });
  }

  handleChangeCheckbox(e, name) {
    const { checked } = e.target;
    this.setState({ [name]: checked }, () => {
      this.updateShareIfNecessary();
    });
  }

  changeLinkRequireLogin(e) {
    this.handleChangeCheckbox(e, 'linkRequireLogin');
  }

  resetModalView(e) {
    const { openLinkSettings } = this.props;

    e.preventDefault();
    this.setState({ modalView: null }, () => {
      openLinkSettings(false);
    });
  }

  openSettings(e) {
    const { openLinkSettings } = this.props;

    if (e) {
      e.preventDefault();
    }
    this.setState({ modalView: 'settings' }, () => {
      openLinkSettings(true);
    });
  }

  isSaveButtonDisabled() {
    const {
      files,
      collections,
      selectedUsers,
      saving,
      editing,
      includeFutureFiles,
    } = this.state;

    if (editing) {
      return false;
    }
    if (includeFutureFiles && collections.length > 0) {
      return false;
    }
    if (selectedUsers.length === 0) {
      return true;
    }
    if (files.length === 0 && collections.length === 0) {
      return true;
    }
    if (saving) {
      return true;
    }

    return false;
  }

  handleChangeComment(e) {
    const { value } = e.target;
    this.setState({ comment: value, unsaved: true });
  }

  handleChangeView(e) {
    const { value } = e.target;

    this.handleChangeTemplate(null);
    this.setState({ view: value }, () => {
      this.updateShareIfNecessary();
    });
  }

  handleChangeTemplate(template, callback = () => {}, silent = false, templatesOverride = null) {
    const { templates: stateTemplates, unsaved } = this.state;
    const templates = templatesOverride || stateTemplates;
    if (template === null) {
      this.setState({ template, unsaved: silent ? unsaved : true }, () => { callback(); });
      return;
    }

    const targetTemplate = templates.find(p => p.uuid === template.value);
    const templatesettings = {};

    Object.keys(shareUserSettingsMap).forEach(key => {
      templatesettings[shareUserSettingsMap[key]] = getShareOptionValue(key, targetTemplate);
    });

    if (templatesettings.logo && templatesettings.logoUrl !== templatesettings.logo) {
      templatesettings.logoUrl = templatesettings.logo;
    }

    this.setState({
      ...templatesettings,
      template: template.value,
      unsaved: silent ? unsaved : true,
    }, () => { callback(); });
  }

  handleChangeColor(color) {
    this.handleChangeTemplate(null);
    this.setState({ color }, () => {
      this.updateShareIfNecessary();
    });
  }

  handleChangeLogo(logo) {
    this.handleChangeTemplate(null);
    this.setState(prevState => ({
      logo,
      logoUrl: logo ? prevState.logoUrl : null,
    }), () => {
      this.updateShareIfNecessary();
    });
  }

  handleChangeLogoUrl(url) {
    this.setState({ logoUrl: url });
  }

  handleChangeAllowDownload(e) {
    const { checked } = e.target;

    this.handleChangeTemplate(null);
    this.handleChangeCheckbox(e, 'allowDownload');

    if (!checked) {
      this.handleChangeCheckbox(e, 'downloadReasons');
      this.handleChangeCheckbox(e, 'selectFileSizes');
    }
  }

  handleChangeDownloadReasons(e) {
    this.handleChangeTemplate(null);
    this.handleChangeCheckbox(e, 'downloadReasons');
  }

  handleChangeWatermark(e) {
    this.handleChangeTemplate(null);
    this.handleChangeCheckbox(e, 'watermark');
  }

  handleChangeIncludeFutureFiles(e) {
    this.handleChangeTemplate(null);
    this.handleChangeCheckbox(e, 'includeFutureFiles');
  }

  handleChangeRequireName(e) {
    this.handleChangeTemplate(null);
    this.handleChangeCheckbox(e, 'requireName');
  }

  handleChangeRequireEmail(e) {
    this.handleChangeTemplate(null);
    this.handleChangeCheckbox(e, 'requireEmail');
  }

  handleChangeRequireAcceptDocument(e) {
    this.handleChangeTemplate(null);
    this.handleChangeCheckbox(e, 'requireAcceptDocument');
  }

  handleChangeSelectFileSizes(e) {
    const {
      availableFileSizes,
    } = this.props;

    this.handleChangeTemplate(null);
    this.handleChangeCheckbox(e, 'selectFileSizes');

    const allFileSizesIds = ['original', ...availableFileSizes.map(fs => `${fs.id}`)];
    this.setState({
      fileSizes: allFileSizesIds,
    });
  }

  handleFileSizesChange(e) {
    const {
      fileSizes,
    } = this.state;
    const {
      value,
      checked,
    } = e.target;

    this.handleChangeTemplate(null);
    this.setState({ unsaved: true });

    if (checked) {
      this.setState(prevState => ({
        fileSizes: [...prevState.fileSizes, `${value}`],
      }));
    } else if (fileSizes.length > 1) {
      this.setState(prevState => ({
        fileSizes: prevState.fileSizes.filter(sfs => (sfs !== `${value}`)),
      }));
    }
  }

  handleClose() {
    const { intl, handleClose } = this.props;

    addFlashMessage({
      type: 'success',
      text: intl.formatMessage({ defaultMessage: 'Your changes have been saved' }),
    });
    handleClose();
  }

  handleChangeRequirePassword(e) {
    this.handleChangeCheckbox(e, 'requirePassword');
  }

  handleChangeStatusChange(e) {
    this.handleChangeTemplate(null);
    this.handleChangeCheckbox(e, 'statusChange');
  }

  handleChangePassword(e) {
    this.setState({
      password: e.target.value,
      unsaved: true,
    });
  }

  handleChangeAllowComments(e) {
    this.handleChangeTemplate(null);
    this.handleChangeCheckbox(e, 'allowComments');
  }

  handleChangeShowPeople(e) {
    this.handleChangeTemplate(null);
    this.handleChangeCheckbox(e, 'showPeople');
  }

  handleChangeAllowFavoriting(e) {
    this.handleChangeTemplate(null);
    this.handleChangeCheckbox(e, 'allowFavoriting');
  }

  handleChangeAllowVersions(e) {
    this.handleChangeTemplate(null);
    this.handleChangeCheckbox(e, 'allowVersions');
  }

  handleChangeHideFileDetails(e) {
    this.handleChangeTemplate(null);
    this.handleChangeCheckbox(e, 'hideFileDetails');
    if (e.target.checked) {
      this.setState({ allowComments: false });
    }
  }

  handleNewTemplateName(newTemplateName) {
    this.setState({ newTemplateName });
  }

  handleNewTemplateNameError(newTemplateNameError) {
    this.setState({ newTemplateNameError });
  }

  handleNewTemplateDestination(newTemplateDestination) {
    this.setState({ newTemplateDestination });
  }

  handleAddingTemplateWrapper(addingTemplate) {
    const {
      handleAddingTemplate,
    } = this.props;

    handleAddingTemplate(addingTemplate);
    this.setState({ addingTemplate });
  }

  handleCreateShareTemplate = async () => {
    const {
      intl,
    } = this.props;
    const {
      newTemplateName,
      newTemplateDestination,
      linkRequireLogin,
      allowDownload,
      downloadReasons,
      statusChange,
      allowComments,
      showPeople,
      allowFavoriting,
      allowVersions,
      includeFutureFiles,
      requireName,
      requireEmail,
      requireAcceptDocument,
      selectFileSizes,
      fileSizes,
      watermark,
      view,
      color,
      logo,
      logoUrl,
    } = this.state;

    this.setState({
      addingTemplateLoading: true,
      newTemplateNameError: false,
    });

    if (newTemplateName.length === 0) {
      this.setState({
        newTemplateNameError: true,
      });
      return;
    }

    const currentShareSettings = {
      login_required: linkRequireLogin,
      allow_download: allowDownload,
      download_reasons: downloadReasons,
      status_change: statusChange,
      allow_comments: allowComments,
      show_people: showPeople,
      allow_favoriting: allowFavoriting,
      allow_versions: allowVersions,
      include_future_files: includeFutureFiles,
      require_email: requireEmail,
      require_name: requireName,
      require_accept_document: requireAcceptDocument,
      select_file_sizes: selectFileSizes,
      file_sizes: fileSizes,
      watermark,
      view,
      color,
      logo,
      logo_url: logoUrl || logo || null,
    };

    const uuid = uuidv4();

    try {
      await APIcreateShareTemplate({
        uuid,
        name: newTemplateName,
        ...currentShareSettings,
        destination: newTemplateDestination,
      });
      this.setState({
        template: uuid,
      });
      addFlashMessage({
        type: 'success',
        text: intl.formatMessage({ defaultMessage: 'New template saved' }),
      });
      this.loadShareTemplates();
    } finally {
      this.setState({
        addingTemplateLoading: false,
      });
      this.handleAddingTemplateWrapper(false);
    }
  };

  handleSave(finish) {
    const {
      shareUuid,
      files,
      collections,
      selectedUsers,
      linkRequireLogin,
      expirationDate,
      comment,
      view,
      allowDownload,
      downloadReasons,
      requirePassword,
      password,
      statusChange,
      allowComments,
      showPeople,
      allowFavoriting,
      allowVersions,
      hideFileDetails,
      watermark,
      includeFutureFiles,
      requireName,
      requireEmail,
      requireAcceptDocument,
      selectFileSizes,
      fileSizes,
      modalView,
      color,
      logo,
      template,
      links,
    } = this.state;
    const {
      request,
      afterUpdateShare,
      filesParams,
    } = this.props;
    const finished = finish || false;

    if (finish) {
      if (requirePassword && (!password || password.length < 3)) {
        this.setState({ passwordError: true });
        this.openSettings();
        return;
      }
    }

    this.setState({
      passwordError: false,
      saving: true,
    });

    const share = {
      files: files.map(f => (f.uuid)),
      collections: collections.map(c => (c.uuid)),
      request: null,
      links: links.map(link => link.short_link_url),
      users: selectedUsers.map(u => ({
        uuid: u.uuid,
        email: u.email,
        type: u.type,
        short_link_url: u.short_link_url,
      })),
      login_required: linkRequireLogin,
      expires_at: expirationDate ? expirationDate.format('YYYY-MM-DD HH:mm:ss') : null,
      comment,
      allow_download: allowDownload,
      download_reasons: downloadReasons,
      require_password: requirePassword,
      password,
      status_change: statusChange,
      allow_comments: allowComments,
      show_people: showPeople,
      allow_favoriting: allowFavoriting,
      allow_versions: allowVersions,
      hide_file_details: hideFileDetails,
      watermark,
      include_future_files: includeFutureFiles,
      require_name: requireName,
      require_email: requireEmail,
      require_accept_document: requireAcceptDocument,
      select_file_sizes: selectFileSizes,
      file_sizes: fileSizes,
      template,
      color,
      logo,
      view,
      order: [filesParams.orderby, filesParams.order],
      finished,
    };

    if (request) {
      share.request = {
        uuid: request.uuid,
        user: request.user.uuid,
        files: files.map(f => (f.uuid)),
        collections: request.collections.map(c => (c.uuid)),
      };
    }

    if (shareUuid) {
      APIupdateShare(shareUuid, share).then((response) => {
        this.setState({
          saving: false,
          modalView: finished ? 'success' : modalView,
        }, () => {
          if (finished) {
            afterUpdateShare(response.data);
            this.handleClose();
          }
        });
      }).catch((error) => {
        const { response } = error;
        if (response.data.errors.password) {
          this.setState({ passwordError: true });
          this.openSettings();
        } else {
          this.setState({
            errors: response.data.errors,
            modalView: response.data.errors ? modalView : 'error',
          });
        }
      }).finally(() => {
        this.setState({ saving: false });
      });
    } else {
      APIcreateShare(share).then((response) => {
        const { data } = response;
        sendTrackingEvent('share-complete', {
          files: files.length,
          collections: collections.length,
        });
        performOnboardingStep('share-complete');
        this.setState({
          saving: false,
          shareUuid: (data && data.uuid) ? data.uuid : null,
          links: data.links || [],
          modalView: finished ? 'success' : modalView,
        }, () => {
          if (finished) {
            sendTrackingEvent('share-modal-close');
            this.handleClose();
          }
        });
      }).catch(() => {
        this.setState({
          saving: false,
          modalView: 'error',
        });
      });
    }
  }

  updateShareIfNecessary() {
    const {
      shareUuid,
      editing,
      addingTemplate,
    } = this.state;

    if (shareUuid && !editing && !addingTemplate) {
      this.handleSave(false);
    }
  }

  render() {
    const {
      collections,
      mode,
      unsaved,
      modalView,
      shareLoading,
      summaryLoading,
      initialStateLoading,
      templatesLoading,
      editing,
      saving,
      allCollectionsCount,
      requestLoading,
      errors,
      templates,
      newTemplateName,
      newTemplateNameError,
      newTemplateDestination,
      addingTemplateLoading,
      addingTemplate,
      summary,
      hasRestrictedFiles,
    } = this.state;
    const {
      intl,
      client,
      share,
      request,
      inAccessModal,
      handleClose,
    } = this.props;

    const canManageShare = canUserManageShare();
    const downloadReasonsAvailable = getSetting('download_reasons').length > 0 && !hasRestrictedFiles;

    return (
      <ErrorBoundary>
        {!inAccessModal && (
          <ShareModalHeader
            {...this.state}
            addingTemplate={addingTemplate}
            handleClose={handleClose}
          />
        )}
        {!mode && (
          <ModalBody>
            {(
              (share && shareLoading) ||
              (!share && summaryLoading) ||
              (!share && initialStateLoading) ||
              (!share && templatesLoading) ||
              (request && requestLoading)
            ) && (
            <Loading />
            )}
          </ModalBody>
        )}

        {(mode && !modalView) && (
          <ModalBody className={classnames({ 'modal-body-editing-mode': addingTemplate })}>
            {unsaved && (
              <div className="modal-body-unsaved-info">
                <p>
                  {
                    intl.formatMessage(
                      { defaultMessage: 'Copy your link and click {buttonText} to save changes' },
                      {
                        buttonText: this.getSaveButtonText(),
                      },
                    )
                  }
                </p>
              </div>
            )}
            <ShareModalLinkSharing
              {...this.state}
              handleAdd={this.addSelectedUser}
              openSettings={this.openSettings}
              changeLinkSuffix={this.changeLinkSuffix}
              errors={errors}
            />
            {this.getShortLink().suffix && (
              <>
                <ShareModalTemplates
                  {...this.state}
                  templates={templates}
                  handleChangeTemplate={this.handleChangeTemplate}
                  handleAddingTemplate={this.handleAddingTemplateWrapper}
                  simple={true}
                  handleClose={handleClose}
                  openSettings={this.openSettings}
                  addingTemplate={addingTemplate}
                />
                <ShareModalComment
                  {...this.state}
                  handleChange={this.handleChangeComment}
                />
                {(collections.length > 0 || (editing && allCollectionsCount > 0)) && (
                  <ShareModalIncludeFutureFiles
                    {...this.state}
                    disabled={summary.smart_collections > 0 || shareLoading || summaryLoading}
                    tooltip={!(shareLoading || summaryLoading)}
                    handleChange={this.handleChangeIncludeFutureFiles}
                  />
                )}
              </>
            )}
          </ModalBody>
        )}

        {modalView === 'settings' && (
          <ModalBody className={classnames({ 'modal-body-editing-mode': addingTemplate })}>
            <ShareModalTemplates
              {...this.state}
              templates={templates}
              handleChangeTemplate={this.handleChangeTemplate}
              handleAddingTemplate={this.handleAddingTemplateWrapper}
              loadShareTemplates={this.loadShareTemplates}
              handleClose={handleClose}
              name={newTemplateName}
              nameError={newTemplateNameError}
              destination={newTemplateDestination}
              handleName={this.handleNewTemplateName}
              handleDestination={this.handleNewTemplateDestination}
              addingTemplate={addingTemplate}
            />

            {!canManageShare && (
              <>
                <ShareModalExpirationDate
                  {...this.state}
                  handleChangeDate={this.changeExpirationDate}
                />
                <ShareModalPasswordProtect
                  {...this.state}
                  handleChangeRequirePassword={this.handleChangeRequirePassword}
                  handleChangePassword={this.handleChangePassword}
                />
              </>
            )}

            <ShareModalView
              {...this.state}
              handleChangeView={this.handleChangeView}
            />
            <ShareModalHideFileDetails
              {...this.state}
              handleChange={this.handleChangeHideFileDetails}
            />
            {canManageShare && (
              <ShareModalExpirationDate
                {...this.state}
                handleChangeDate={this.changeExpirationDate}
              />
            )}
            <ShareModalAllowDownload
              {...this.state}
              handleChange={this.handleChangeAllowDownload}
            />
            {downloadReasonsAvailable && (
              <ShareModalDownloadReasons
                {...this.state}
                handleChange={this.handleChangeDownloadReasons}
              />
            )}
            <ShareModalRequireName
              {...this.state}
              handleChange={this.handleChangeRequireName}
            />
            <ShareModalRequireEmail
              {...this.state}
              handleChange={this.handleChangeRequireEmail}
            />
            {getSetting('shares_require_accept_document') === '1' && (
              <ShareModalRequireAcceptDocument
                {...this.state}
                handleChange={this.handleChangeRequireAcceptDocument}
              />
            )}
            <ShareModalWatermark
              {...this.state}
              watermarkEnabled={!!client.watermark_url}
              handleChange={this.handleChangeWatermark}
              handleClose={handleClose}
            />
            <ShareModalRequireLogin
              {...this.state}
              handleChange={this.changeLinkRequireLogin}
            />
            {canManageShare && (
              <ShareModalPasswordProtect
                {...this.state}
                handleChangeRequirePassword={this.handleChangeRequirePassword}
                handleChangePassword={this.handleChangePassword}
              />
            )}
            <ShareModalAllowComments
              {...this.state}
              handleChangeAllowComments={this.handleChangeAllowComments}
              handleClose={handleClose}
            />
            <ShareModalShowPeople
              {...this.state}
              handleChangeShowPeople={this.handleChangeShowPeople}
              handleClose={handleClose}
            />
            <ShareModalAllowFavoriting
              {...this.state}
              handleChangeAllowFavoriting={this.handleChangeAllowFavoriting}
              handleClose={handleClose}
            />
            <ShareModalAllowVersions
              {...this.state}
              handleChangeAllowVersions={this.handleChangeAllowVersions}
              handleClose={handleClose}
            />
            <ShareModalStatusChange
              {...this.state}
              handleChangeStatusChange={this.handleChangeStatusChange}
              handleClose={handleClose}
            />
            <ShareModalSelectFileSizes
              {...this.state}
              handleChange={this.handleChangeSelectFileSizes}
              handleFileSizesChange={this.handleFileSizesChange}
            />
            <ShareModalColor
              {...this.state}
              handleChange={this.handleChangeColor}
            />
            <ShareModalLogo
              {...this.state}
              handleChange={this.handleChangeLogo}
              handleChangeLogoUrl={this.handleChangeLogoUrl}
              small={true}
            />
          </ModalBody>
        )}

        {modalView === 'error' && (
          <ModalBody className="modal-msg-body modal-msg-error">
            <Container>
              <Row>
                <Col>
                  {intl.formatMessage({ defaultMessage: 'Something went wrong. Please try again or contact us.' })}
                </Col>
              </Row>
            </Container>
          </ModalBody>
        )}

        {(!modalView && !inAccessModal) && (
          <ModalFooter className="justify-right">
            <div className="modal-footer-wrapper">
              <div className="buttons-group">
                <Button
                  color="primary"
                  onClick={() => {
                    this.handleSave(true);
                  }}
                  disabled={this.isSaveButtonDisabled()}
                >
                  <ProcessingSpinner show={saving} />
                  {this.getSaveButtonText()}
                </Button>
              </div>
            </div>
          </ModalFooter>
        )}

        {((modalView === 'settings' || modalView === 'error') && !addingTemplate) && (
          <ModalFooter className="justify-l">
            <div className="modal-footer-wrapper">
              <div className="buttons-group">
                <Button color="link" onClick={this.resetModalView} disabled={saving}>
                  <i className="far fa-long-arrow-left" />
                  {intl.formatMessage({ defaultMessage: 'Back' })}
                </Button>
              </div>
            </div>
          </ModalFooter>
        )}

        {(modalView === 'settings' && addingTemplate) && (
          <ModalFooter className={classnames({ 'modal-footer-editing-mode': addingTemplate })}>
            <div className="modal-footer-wrapper">
              <div className="buttons-group">
                <Button color="secondary" onClick={() => this.handleAddingTemplateWrapper(false)}>
                  {intl.formatMessage({ defaultMessage: 'Cancel' })}
                </Button>
                <Button color="primary" onClick={this.handleCreateShareTemplate} disabled={addingTemplateLoading}>
                  <ProcessingSpinner show={addingTemplateLoading} />
                  {intl.formatMessage({ defaultMessage: 'Create new template' })}
                </Button>
              </div>
            </div>
          </ModalFooter>
        )}
      </ErrorBoundary>
    );
  }
}

const mapStateToProps = state => ({
  client: state.Auth.profile?.client,
  allFiles: state.Files.files,
  allCollections: state.Collections.collections,
  availableFileSizes: state.App.fileSizes,
  filesParams: state.Files.params,
});

ShareModal.propTypes = {
  intl: PropTypes.object.isRequired,
  client: PropTypes.object.isRequired,
  allFiles: PropTypes.array.isRequired,
  allCollections: PropTypes.array.isRequired,
  availableFileSizes: PropTypes.array.isRequired,
  filesParams: PropTypes.object.isRequired,
  share: PropTypes.object,
  files: PropTypes.array,
  collections: PropTypes.array,
  request: PropTypes.object,
  inAccessModal: PropTypes.bool,
  accessSaving: PropTypes.bool,
  handleClose: PropTypes.func.isRequired,
  afterUpdateShare: PropTypes.func,
  openLinkSettings: PropTypes.func,
  setShareLink: PropTypes.func,
  addingTemplate: PropTypes.bool,
  handleAddingTemplate: PropTypes.func,
};

ShareModal.defaultProps = {
  share: null,
  files: [],
  collections: [],
  request: null,
  inAccessModal: false,
  accessSaving: false,
  addingTemplate: false,
  handleAddingTemplate: () => {},
  afterUpdateShare: () => {},
  openLinkSettings: () => {},
  setShareLink: () => {},
};

export default connect(mapStateToProps)(injectIntl(ShareModal));
